type PaletteColor =
  | "newBlue"
  | "newBrightGreen"
  | "newDarkGreen"
  | "newLavender"
  | "newPeach"
  | "newPink"
  | "newReddish"
  | "newYellow";

type PaletteKeys = 50 | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900;
type PaletteMap = Record<PaletteKeys, string>;

const palettes: Record<PaletteColor, PaletteMap> = {
  newBlue: {
    50: "#D9F7FF",
    100: "#C2E0FF",
    200: "#ACC9EC", // referenced directly
    300: "#96B3D5",
    400: "#809EBF",
    500: "#6B89A9",
    600: "#577594",
    700: "#43617F",
    800: "#2F4E6B",
    900: "#1A3C57",
  },
  // Used in colorScheme
  newBrightGreen: {
    50: "#D4FFBF",
    100: "#BEE9A9", // referenced directly
    200: "#A7D294",
    300: "#92BC7F",
    400: "#7DA66B", // referenced directly
    500: "#689157",
    600: "#547C44",
    700: "#406831",
    800: "#2D551F",
    900: "#19420D",
  },
  // Used in colorScheme
  newDarkGreen: {
    50: "#C3FFEB",
    100: "#ADE9D4", // referenced directly
    200: "#97D3BE",
    300: "#82BCA8", // referenced directly
    400: "#6DA693", // referenced directly
    500: "#58917E",
    600: "#447C6A",
    700: "#306857", // referenced directly
    800: "#1A5544",
    900: "#014232", // referenced directly
  },
  newLavender: {
    50: "#E4F2FF",
    100: "#CDDBFF", // referenced directly
    200: "#B7C5F7",
    300: "#A1AFE0",
    400: "#8B9ACA",
    500: "#7685B4",
    600: "#61719E",
    700: "#4D5D89",
    800: "#394A75",
    900: "#243861",
  },
  newPeach: {
    50: "#FFDDCA",
    100: "#FFC7B4", // referenced directly
    200: "#FFB19E", // referenced directly
    300: "#EF9B89",
    400: "#D88675", // referenced directly
    500: "#C07161", // referenced directly
    600: "#A95D4E",
    700: "#92493B",
    800: "#7C362A",
    900: "#662319",
  },
  newPink: {
    50: "#FFE5E0", // referenced directly
    100: "#FFCECA", // referenced directly
    200: "#F3B8B4", // referenced directly
    300: "#DCA29F",
    400: "#C58D8A",
    500: "#AF7875",
    600: "#996461",
    700: "#83514E",
    800: "#6E3E3C",
    900: "#5A2C2B",
  },
  // Used in colorScheme
  newReddish: {
    50: "#FFCFCC",
    100: "#FFB8B6", // referenced directly
    200: "#FFA2A0", // referenced directly
    300: "#FF8C8B",
    400: "#F07677",
    500: "#D86163", // referenced directly
    600: "#BF4B50",
    700: "#A8363D",
    800: "#901F2C",
    900: "#79001B",
  },
  newYellow: {
    50: "#FFF0B1",
    100: "#F7DA9C", // referenced directly
    200: "#E0C387",
    300: "#C9AD72",
    400: "#B2985E",
    500: "#9C834A",
    600: "#866F37",
    700: "#715C25",
    800: "#5C4912",
    900: "#483700",
  },
};

const th = {
  white: "#FFFFFF",
  blueAlert1: "#F4F9FF",
  blueAlert2: "#6FA6DE",
  blueAlert3: "#0E69C7",
  cream1: "#FCF9F1",
  cream2: "#F4EEE1",
  cream3: "#DBD4C5",
  cream4: "#AEA591",
  gray1: "#E7E8E8",
  gray2: "#C3C6C5",
  gray3: "#A0A3A3",
  gray4: "#6D7472",
  black: "#111A18",
  signatureGreen: "#1A5544", // newDarkGreen.800
  signatureGreen40: "#A3BBB4",
  lavender1: "#D3E2FF",
  actionLavenderPrimary: "#B5CEFF",
  actionLavender1: "#A2B6FF",
  actionLavender2: "#859CEB",
  textLavender1: "#425DBA",
  textLavender2: "#081BC8",

  pink1: "#FFCFCC", // newReddish.50
  pink2: "#FF8C8B", // newReddish.300
  pink3: "#B45849",
  peach1: "#FFDDCA", // newPeach.50
  peach2: "#EF9B89", // newPeach.300
  yellow1: "#FFF0B1", // newYellow.50
  yellowGreen1: "#D4FFBF", // newBrightGreen.50
  lightGreent1: "#F3FFED",
  blueGreen1: "#C3FFEB", // newDarkGreen.50
  blueGreen2: "#2C7E69",
  blue1: "#C2E0FF", // newBlue.100
  danger1: "#C02121",
  danger1Hover: "#FF8C8B",
  redAlert1: "#FCF4F2",
  redAlert2: "#DB9A90",
  redAlert3: "#8E1400",
};

export const colors = {
  ...palettes,
  brand: palettes.newDarkGreen,
  th,
};
